export class TaxOverrides {
    public static ADDED = 'ADDED';
    public static INCLUDED = 'INCLUDED';
}
